import { render, staticRenderFns } from "./CoverSetting.vue?vue&type=template&id=e8a39292&scoped=true"
import script from "./CoverSetting.vue?vue&type=script&lang=js"
export * from "./CoverSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a39292",
  null
  
)

export default component.exports